import React from "react";
import { Icon, MenuItem, Spinner, Tag } from "@blueprintjs/core";
import { Suggest } from "@blueprintjs/select";

class AsyncSelWrap extends React.Component {
 constructor(props) {
  super(props);
  this.suggestRef = React.createRef();
 }
 state = {
  item: null,
  width: "100px",
 };

 renderMI = (item, query) => {
  return (
   <div className="axis">
    {this.highlightText(item.item, query)}
    <br />
    <Tag minimal>{item.entityTypeString}</Tag>
    <Icon icon="caret-right" minimal />
    <Tag minimal>{item.helper}</Tag>
    {item.helper2 ? <Icon icon="caret-right" minimal /> : null}
    {item.helper2 ? <Tag minimal>{item.helper2}</Tag> : null}
   </div>
  );
 };
 renderItem = (item, { handleClick, modifiers, query }) => {
  if (!modifiers.matchesPredicate) {
   return null;
  }
  let label = null;

  return (
   <MenuItem
    key={item._id || undefined}
    className="axis"
    style={{ width: "500px" }}
    active={modifiers.active}
    disabled={modifiers.disabled}
    onClick={handleClick}
    text={this.renderMI(item, query)}
    shouldDismissPopover={false}
    label={label}
   />
  );
 };
 escapeRegExpChars = (text) => {
  return text.replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1");
 };
 highlightText = (text, query) => {
  let lastIndex = 0;
  const words = query
   .split(/\s+/)
   .filter((word) => word.length > 0)
   .map(this.escapeRegExpChars);
  if (words.length === 0) {
   return [text];
  }
  const regexp = new RegExp(words.join("|"), "gi");
  const tokens = [];
  while (true) {
   const match = regexp.exec(text);
   if (!match) {
    break;
   }
   const length = match[0].length;
   const before = text.slice(lastIndex, regexp.lastIndex - length);
   if (before.length > 0) {
    tokens.push(before);
   }
   lastIndex = regexp.lastIndex;
   tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
  }
  const rest = text.slice(lastIndex);
  if (rest.length > 0) {
   tokens.push(rest);
  }
  return tokens;
 };
 handleItemSelect = (item) => {
  this.setState({ item: item.item });
  this.props.onChange(item);
 };
 filterItem = (query, item) => {
  /** Implement Any Random Search Here which returns a Boolean */
  /** Correspondingly IF you want aesthetics, change `highlightText` */
  return true;
 };

 // Method to focus on the input
 focus = () => {
  if (this.suggestRef.current && this.suggestRef.current.querySelector) {
   const input = this.suggestRef.current.querySelector("input");
   if (input) {
    input.focus();
   }
  }
 };

 render() {
  let inputProps = {};
  if (this.props.placeholder) {
   inputProps["placeholder"] = this.props.placeholder;
  }
  if (!this.props.width) {
   inputProps["style"] = { width: "300px" };
  }
  let items = this.props.items;

  return (
   <div ref={this.suggestRef}>
    <Suggest
     className="axis"
     onQueryChange={(event) => this.props.update(event)}
     inputProps={{
      disabled: this.props.disabled,
      className: "focus-input",
      placeholder: this.props.placeholder || "Search...",
      ...(this.props.inputProps || {}),
     }}
     itemPredicate={(query, item) => {
      const q = (query || "").trim().toLowerCase();
      if (!q) return true;
      const pid = (item.entityTypeString || "").toLowerCase();
      const name = (item.item || "").toLowerCase();
      const phone = (item.helper || "").toLowerCase();
      // If exact PID match, show only that entry
      if (pid && pid === q) return true;
      // Otherwise allow partial matches on PID, name, or phone
      return pid.includes(q) || name.includes(q) || phone.includes(q);
     }}
     items={items}
     noResults={
      this.props.searching ? (
       <MenuItem
        disabled={true}
        className="axis"
        label={<Spinner size={20} />}
        text="Searching..."
       />
      ) : (
       <MenuItem
        className="axis"
        disabled={true}
        text="Start typing to search."
       />
      )
     }
     itemRenderer={this.renderItem}
     selectedItem={
      this.props.showSelectProp
       ? this.props.selectedItem
       : this.props.selectedItem || this.state.item || null
     }
     onItemSelect={this.handleItemSelect}
     inputValueRenderer={(item) => {
      return item ? item.item : "";
     }}
     popoverProps={{ minimal: true, ...(this.props.popoverProps || {}) }}
    />
   </div>
  );
 }
}

export default AsyncSelWrap;
